import styled from 'styled-components';

const ToolbarContainer = styled.div.attrs({
  className: 'flex justify-between items-center mt-1 sm:flex-col',
})`
  & > div:first-child {
    width: 100%;
    input {
      width: 80%;
      border: 1px solid #aaa;
      padding: 4px 8px;
    }
  }

  .toolbar {
    button {
      padding: 0px;
      height: auto;

      &.add-video-btn {
        padding: 4px 8px;
        background: lightgray;
        border-radius: 4px;

        &:hover {
          background: #eee;
        }
      }
    }
  }
`;

export { ToolbarContainer };
